import React from "react";
import { Logo } from "../Logo";
import { smoothScrollTo } from "../SmoothScroll";
import { openWhatsApp, WHATSAPP_DISPLAY } from "../../lib/whatsapp";

const LINKS = [
  { label: "About", href: "#about" },
  { label: "Products", href: "#products" },
  { label: "Why Us", href: "#why-us" },
  { label: "Process", href: "#process" },
  { label: "Gallery", href: "#gallery" },
  { label: "Contact", href: "#contact" },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="relative bg-forestDeep text-cream/85 pt-24 md:pt-32 pb-10 overflow-hidden"
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.05]"
        style={{
          backgroundImage:
            "repeating-linear-gradient(-45deg, #FAF7F0 0 1px, transparent 1px 22px)",
        }}
      />

      <div className="relative mx-auto max-w-[1400px] px-6 md:px-10">
        {/* Big tagline */}
        <div className="grid lg:grid-cols-12 gap-10 pb-16 md:pb-24 border-b border-cream/15">
          <div className="lg:col-span-7">
            <h3 className="font-serif font-light text-4xl md:text-6xl lg:text-7xl leading-[0.98]">
              Bring home the <span className="italic text-gold">green.</span>
            </h3>
            <p className="mt-6 font-sans text-cream/70 text-base md:text-[17px] max-w-[48ch] leading-relaxed">
              Small trades, done properly — one owner, one WhatsApp, one
              honest handshake per shipment.
            </p>
          </div>
          <div className="lg:col-span-5 lg:pl-10 lg:border-l lg:border-cream/15 flex flex-col justify-end">
            <button
              onClick={() => openWhatsApp()}
              data-testid="footer-enquire-cta"
              className="self-start inline-flex items-center gap-3 rounded-full bg-gold text-forestDeep px-7 py-4 text-[12px] uppercase tracking-[0.28em] font-medium hover:bg-cream transition-colors"
            >
              Enquire on WhatsApp
              <span className="inline-block h-1.5 w-1.5 rounded-full bg-forest" />
            </button>
            <a
              href={`tel:+918121448600`}
              className="mt-6 font-serif italic text-2xl md:text-3xl text-cream hover:text-gold transition-colors self-start"
              data-testid="footer-phone-link"
            >
              {WHATSAPP_DISPLAY}
            </a>
          </div>
        </div>

        {/* Columns */}
        <div className="grid md:grid-cols-12 gap-10 py-14">
          <div className="md:col-span-5">
            <Logo variant="light" compact />
            <p className="mt-6 font-sans text-cream/60 text-sm max-w-[38ch] leading-relaxed">
              Sourcing &amp; exporting premium green cardamom out of Ongole,
              Prakasam District, Andhra Pradesh — since day one.
            </p>
          </div>
          <div className="md:col-span-3">
            <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-cream/50 mb-5">
              Navigate
            </div>
            <ul className="space-y-3">
              {LINKS.map((l) => (
                <li key={l.href}>
                  <button
                    onClick={() => smoothScrollTo(l.href)}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-serif text-xl text-cream/90 hover:text-gold transition-colors"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="md:col-span-4">
            <div className="font-sans text-[11px] uppercase tracking-[0.32em] text-cream/50 mb-5">
              Reach us
            </div>
            <address className="not-italic font-serif text-xl text-cream/90 leading-snug">
              The Cardamom Trading Co.
              <br />
              Ongole, Prakasam District
              <br />
              Andhra Pradesh, India
            </address>
            <div className="mt-4 font-sans text-sm text-cream/70">
              Mon – Sat · 9 am to 8 pm IST
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/15 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-sans text-[11px] uppercase tracking-[0.28em] text-cream/50">
          <span>© {year} The Cardamom Trading Co. All rights reserved.</span>
          <span className="font-serif italic normal-case tracking-normal text-cream/60">
            Elettaria cardamomum · sourced with intent.
          </span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
